"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCognitoUserPoolEndpointResolver = void 0;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var createCognitoUserPoolEndpointResolver_1 = require("./createCognitoUserPoolEndpointResolver");
Object.defineProperty(exports, "createCognitoUserPoolEndpointResolver", { enumerable: true, get: function () { return createCognitoUserPoolEndpointResolver_1.createCognitoUserPoolEndpointResolver; } });
